/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { createAgent } from "@vlinder-web/plugin-agent-service-react";
import {
  IStaticPageContentMethods,
  StaticPageContentService,
  GetCostumeTypeService,
  IGetCostumeTypeMethods,
  SettingsService,
  ISettingsMethods,
  CreateMasqBoxService,
  ICreateMasqBoxTypeMethods,
  AdminPresentationListsService,
  IAdminPresentationListsMethods,
  IDiscountPresentationListsMethods,
  DiscountPresentationListsService,
  ISendSinglePurchaseInviteMethods,
  SendSinglePurchaseInviteUserService,
  IMasqueraderListsMethods,
  MasqueraderListsService,
  IPresentationListsMethods,
  PresentationListsService,
  GetCitiesService,
  IGetCitiesMethods,
  IUpdateBoxMethods,
  UpdateBoxService,
} from "./components";

export type CostumePageAgent = IStaticPageContentMethods &
  IGetCostumeTypeMethods &
  IAdminPresentationListsMethods &
  IDiscountPresentationListsMethods &
  ISendSinglePurchaseInviteMethods &
  IMasqueraderListsMethods &
  ISettingsMethods &
  IPresentationListsMethods &
  IGetCitiesMethods &
  IUpdateBoxMethods &
  ICreateMasqBoxTypeMethods;

const getPlugins = () => {
  return [
    new StaticPageContentService(),
    new GetCostumeTypeService(),
    new CreateMasqBoxService(),
    new DiscountPresentationListsService(),
    new SendSinglePurchaseInviteUserService(),
    new MasqueraderListsService(),
    new PresentationListsService(),
    new AdminPresentationListsService(),
    new SettingsService(),
    new GetCitiesService(),
    new UpdateBoxService(),
  ];
};

export const getAgent = () => {
  return createAgent<CostumePageAgent>({
    plugins: getPlugins(),
  });
};
